import * as testConst from 'app/constants/tests';
import { AppStoreState } from 'app/redux/store';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Question } from 'types/test';

interface QuestionCheckboxesProps {
  question: Question;
  groupType: number;
  options: string[];
  confirmIsReady: () => void;
  handleChange: (value: string | null, question: Question) => void
}

const QuestionCheckboxes = (props: QuestionCheckboxesProps) => {
  const [checkList, setCheckList] = useState<string[]>([]);
  const { process } = useSelector((state: AppStoreState) => state.test);
  const isDisable = ['init', 'complete'].includes(process);

  useEffect(() => {
    if (process !== 'complete') {
      setCheckList([]);
    }
  }, [process]);

  const handleChangeCheckBox = (value: string, question: Question) => {
    const newCheckList = checkList.includes(value)
      ? checkList.filter(item => item !== value)
      : [...checkList, value];

    setCheckList(newCheckList);
    props.handleChange(newCheckList.join(','), question);
  };

  if (props.groupType !== testConst.QUESTION_MULTI) return null;

  return (
    <div className="col-md-12">
      {props.options.map((label: string) => {
        const value = label.split('##')[0];

        return (
          <div onClick={props.confirmIsReady} className="group-checkbox mt-2 d-flex" key={label}>
            <input
              id={label}
              type="checkbox"
              className='mr-2'
              disabled={isDisable}
              value={value}
              checked={checkList.includes(value)}
              onChange={() => handleChangeCheckBox(value, props.question)}
            />
            <label htmlFor={label} className="text-dark mt-2">
              {label.replace('##', ' - ')}
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default QuestionCheckboxes;
